import React from 'react';
import {Link} from 'react-router-dom';
import * as d3 from "./d3.modified.js"

export default class PreviewNode extends React.Component {
    componentDidMount() {
        d3.select(this.wrapper)
            .style('opacity', 0)
            .transition()
                .duration(500)
                .style('opacity', 1)
    }

    render() {
        return (
            <div className={this.props.fullSize?'col-lg-12':`col-lg-4 col-md-6 col-sm-12`}>
            <Link to={`/nodebook/${this.props.nodebook}/query/ids=${this.props.node}`}>
                <div className={`node-preview${this.props.nodescription?' nodesc':''}`} ref={c=>this.wrapper=c}>
                    <div className="avatar" style={{backgroundImage: `url(${this.props.info.avatar})`}}></div>
                    <h1>{this.props.info.first_name} {this.props.info.last_name}
                        <small>{this.props.info.username}</small>
                    </h1>
                    {
                        (this.props.nodescription)
                            ? null
                            : <p>{this.props.info.bio}</p>
                    }
                </div>
            </Link>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/PreviewNode.js